import { Loading } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { landData } from "@/shared/utils/landData";
import { VNode } from "vue";

const style = require("./index.module.scss");

@Component({ name: "MyMixns" })
export default class MyMixns extends Vue {
  public getElement(): VNode {
    return (
      <div class={style.main_header}>
        <div class={style.main_width}>
          <span>正在审核的机构</span>
        </div>
      </div>
    );
  }

  public getLoading(): VNode {
    return (
      <div class={style.main_loading}>
        <Loading type="spinner" color="#FF5600" size="15px" />
        <span class={style.main_check}>审核中</span>
      </div>
    );
  }

  // 分期乐-骑行卡
  public get isSourceRideCard(): boolean {
    return landData.getSouce() === "app_fenqile_ride";
  }
}
